export const messages = {
  en: {
    marketSms: {
      search: {
        title: 'Search Conditions',
        smsName: 'Please enter name',
        smsType: 'Please select type'
      },
      list: {
        title: 'Marketing Configuration'
      },
      table: {
        smsId: 'ID',
        smsName: 'Name',
        smsType: 'Type',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      form: {
        smsName: 'Name',
        smsType: 'Type',
        remark: 'Remark'
      },
      placeholder: {
        smsName: 'Please enter name',
        smsType: 'Please select type',
        remark: 'Please enter remark'
      },
      validate: {
        smsName: 'Name is required',
        smsNameMax: 'Name cannot exceed 64 characters',
        smsType: 'Type is required',
        remark: 'Remark is required',
        remarkMax: 'Remark cannot exceed 512 characters',
        smsId: 'ID is required'
      },
      add: {
        title: 'Add Marketing SMS',
        success: 'Add successful'
      },
      edit: {
        title: 'Edit Marketing SMS',
        success: 'Edit successful'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this marketing SMS?',
        success: 'Delete successful'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    marketSms: {
      search: {
        title: '查询条件',
        smsName: '请输入名称',
        smsType: '请选择类型'
      },
      list: {
        title: '营销配置'
      },
      table: {
        smsId: '编号',
        smsName: '名称',
        smsType: '设置类型',
        createTime: '创建时间',
        remark: '备注'
      },
      form: {
        smsName: '名称',
        smsType: '设置类型',
        remark: '备注'
      },
      placeholder: {
        smsName: '请输入名称',
        smsType: '请选择设置类型',
        remark: '请输入备注'
      },
      validate: {
        smsName: '名称不能为空',
        smsNameMax: '名称不能超过64个字符',
        smsType: '设置类型不能为空',
        remark: '备注不能为空',
        remarkMax: '备注不能超过512个字符',
        smsId: '编号不能为空'
      },
      add: {
        title: '添加营销短信',
        success: '添加成功'
      },
      edit: {
        title: '修改营销短信',
        success: '修改成功'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除该营销短信吗？',
        success: '删除成功'
      },
      fetchError: '获取数据失败'
    }
  }
}